
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UsersRepository } from 'src/app/repositories/users.repository';
import { DEFAULT_LANDING_SECTION_ROUTES, DefaultLandingSection } from 'src/app/utils/default-landing-section';
export const InterceptorRefreshHeader = 'X-Skip-Interceptor';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {

	baseUrl = environment.apiUrl;

	constructor(
		private http: HttpClient,
		private router: Router,
		private usersRepo: UsersRepository
	) { }

	// Único punto de navegación tras un login exitoso (login.component.ts por Google y por
	// contraseña, verify-twofa.component.ts tras 2FA) — lee Ajustes > General > "Sección al
	// iniciar sesión" (defaultLandingSection, ver profile.component.ts) y manda ahí en vez de
	// siempre al dashboard. Sin valor guardado (cuentas viejas, o nuevas hasta que back les
	// genere su config por default) cae en '/', el comportamiento de siempre.
	navigateAfterLogin(): void {
		this.usersRepo.getUserConfiguration().subscribe({
			next: (response: any) => {
				let resolved = response?.config;
				while (resolved?.config !== undefined) {
					resolved = resolved.config;
				}
				const section = resolved?.defaultLandingSection as DefaultLandingSection | undefined;
				const route = (section && DEFAULT_LANDING_SECTION_ROUTES[section]) || '/';
				this.router.navigate([route]);
			},
			error: () => this.router.navigate(['/'])
		});
	}

	login(email: string, password: string, network?: string) {
		if(!network)
			network = "apicreate"
		return this.http.post<any>(this.baseUrl + '/auth/login',
						  			{ email, password, network })
			.pipe(map(user => {
				// login successful if there's a jwt token in the response
				if (user) {
					// store user details and jwt token in local storage to keep user logged in between page refreshes
					localStorage.setItem('currentUser', JSON.stringify(user));
				}
				return user;
			}));
	}

	check2fa(data: any){
		return this.http.post<any>(this.baseUrl+'/auth/check2fa', data)
		.pipe(map(user => {
			// login successful if there's a jwt token in the response
			if (user) {
				// store user details and jwt token in local storage to keep user logged in between page refreshes
				localStorage.setItem('currentUser', JSON.stringify(user));
			}
			return user;
		}));
	}

	refresh() {
		let headers = new HttpHeaders({'X-Skip-Interceptor':''});
		return this.http.post<any>(this.baseUrl + '/auth/refresh', null, { headers:headers })
			.pipe(map(user => {
				// login successful if there's a jwt token in the response
				if (user && user.access) {
					let currentUser = JSON.parse(localStorage.getItem('currentUser') ||"{}");
					currentUser.access = user.access;
					// store user details and jwt token in local storage to keep user logged in between page refreshes
					localStorage.setItem('currentUser', JSON.stringify(currentUser));
				}
			return user;
		}));
	}

	logout() {
		// remove user from local storage to log user out
		localStorage.removeItem('currentUser');
	}

}
